var modules_037eb246 = {"container":"CountDown_module_container__025fd1f1"};
import "../../../assets/esm/components/CountDown/src/CountDown~_DbWJRYE.css";

export { modules_037eb246 as default };
//# sourceMappingURL=CountDown.module.less.js.map
